export default {
    data() {
        return {
            // 角色
            mappingRole: [
                // {
                //   text: "開發者",
                //   value: 100
                // },
                {
                    text: "最高管理者",
                    value: 200
                },
                {
                    text: "加盟者",
                    value: 300
                },
                {
                    text: "客服",
                    value: 400
                }
            ],
            // 帳號狀態
            mappingStatus: [
                {
                    text: "啟用",
                    value: "active"
                },
                {
                    text: "停用",
                    value: "disable"
                }
            ],

            // 優惠方案狀態
            mappingAvailable: [
                {
                    text: "啟用",
                    value: true
                },
                {
                    text: "停用",
                    value: false
                }
            ],
            //機器類型
            machineTypeList: [
                {
                    text : '所有類型',
                    value : '',
                },
                {
                    text : 'CCB',
                    value : 'CCB',
                },
                {
                    text : 'CCA',
                    value : 'CCA',
                },
                {
                    text : 'MU',
                    value : 'MU',
                },
            ],
        }
    }
}
